import {XMarkIcon} from "@heroicons/react/24/solid";
import React, {useState} from "react";


const DeleteItem = ({
                        itemIndex = -1,
                        handleDeleteItem,
                        showIcon,
                        size = 'px-1 py-1',
                        iconSize = 'h-5 w-5',
                        confirmLabel = 'Confirm Delete'
                    }) => {
    const [showConfirm, setShowConfirm] = useState(false);
    const handleConfirm = () => {
        handleDeleteItem(itemIndex);
        setShowConfirm(false);
    }

    return (
        <>
            {!showIcon && !showConfirm &&
                <button
                    className={`button-red-outline ${size} text-sm`}
                    onClick={() => setShowConfirm(true)}>
                    Delete
                </button>
            }

            {showIcon && !showConfirm &&
                <button
                    className={`button-red-outline ${size} text-sm`}
                    onClick={() => setShowConfirm(true)}>
                    <div className="">
                        <XMarkIcon className={`${iconSize}`}/>
                    </div>
                </button>
            }

            {showConfirm &&
                <div className={'flex justify-end items-center w-48'}>
                    <div>
                        <button
                            className={`button-red-outline ${size} text-sm`}
                            onClick={handleConfirm}>
                            <div className={'px-1'}>
                                {confirmLabel}
                            </div>
                        </button>
                    </div>

                    <div>
                        <button
                            className={`button-gray-outline ${size} ml-2 text-sm`}
                            onClick={() => setShowConfirm(false)}>
                            <div className={'px-1'}>Cancel</div>
                        </button>
                    </div>
                </div>
            }
        </>
    )
}

export default DeleteItem
